import { types } from "../types";

// Estos ui serian para errores sincronos 
//como los de validacion de formulario No para peticiones
// pero para formularios estoy usando Formik

//Entonces estos serian para validaciones de procesos sincronos

export const setError = (err) => ({
  type: types.uiSetError,
  payload: err,
});
export const removeError = () => ({
  type: types.uiRemoveError,
});


export const setLoading = () => ({
  type: types.uiSetLoading
});

export const removeLoading = () => ({
  type: types.uiRemoveLoading
});

export const openModal = () => ({
  type: types.uiOpenModal
  
})
export const closeModal = () => ({
  type: types.uiCloseModal
})

